import { Box, Button, Popover, Typography } from "@mui/material";
import { useState, MouseEvent } from "react";

import { Product } from "api/memberPortal/project/product/product.types";
import StageTracker from "components/Dashboard/StageTracker/StageTracker";

interface ProductStatusCellProps {
  product: Product;
}

const statusLookup: Record<string, string> = {
  Draft: "In Draft",
  Certified: "Completed",
};

const ProductStatusCell = ({ product }: ProductStatusCellProps) => {
  const { status } = product;
  const buttonTitle = statusLookup[status] ?? status;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flex="1"
      maxWidth={"100%"}
    >
      <Button
        variant={open ? "contained" : "outlined"}
        onClick={handleClick}
        // fullWidth
        sx={{
          px: 0.5,
          py: 0.25,
        }}
      >
        <Typography
          fontSize={11}
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
          p={0}
          m={0}
        >
          {buttonTitle}
        </Typography>
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          "& .MuiPopover-paper": {
            minWidth: 200,
            maxWidth: 600,
            width: "max-content",
            padding: 2,
          },
        }}
      >
        <StageTracker rowData={product} />
      </Popover>
    </Box>
  );
};

export default ProductStatusCell;
